// extracted by mini-css-extract-plugin
export default {"container":"NotFoundPage_container__gq49g","image":"NotFoundPage_image__YiLwW","text":"NotFoundPage_text__wP5SU"};